<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-upload mr-5"></i>Manager</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-xs-12">
          <label class="btn btn-default">
            {{'file_select' | translate}} <input id="fileInput" type="file" @change="onFileChange" style="display: none;">
          </label>
        </div>
      </div>
      <template v-if="files.length > 0">
        <div class="row pt-10" v-for="file, index in files">
          <div class="col-xs-3" >
            <div class="form-group">
              <label>{{'title' | translate}}</label>
              <input v-validate.initial="'required'" :data-vv-scope="'file-' + index" data-vv-as="Title" :name="'title'" class="form-control" type="text" placeholder="Title" v-model="file.title">
              <span v-show="errors.has('file-' + index + '.title')" class="small text-danger">{{ errors.first('file-' + index + '.title') }}</span>
            </div>
          </div>
          <div class="col-xs-3">
            <div class="form-group">
              <label>Sub{{'title' | translate}}</label>
              <input v-validate.initial="'required'" :data-vv-scope="'file-' + index" data-vv-as="Subtitle" :name="'subtitle'" type="text" class="form-control" placeholder="subtitle..." v-model="file.sub_title"/>
              <span v-show="errors.has('file-' + index + '.subtitle')" class="small text-danger">{{ errors.first('file-' + index + '.subtitle') }}</span>
            </div>
          </div>
          <div class="col-xs-3">
            <div class="form-group">
              <label>File Name</label>
              <div>
                <i class="fa fa-file-o mr-5"></i>
                {{file.name + '.' + file.extension}}
              </div>
            </div>
          </div>
          <div class="col-xs-3 text-right">
            <button class="btn btn-danger btn-app" @click="files.splice(index, 1)"><i class="fa fa-ban"></i>{{'cancel' | translate}}</button>
          </div>
        </div>
      </template>
    </div>
    <div class="box-footer" v-if="files.length > 0">
      <div class="text-right">
        <button :disabled="errors.any()" class="btn btn-app btn-success" id="uploadButton" @click="uploadAll()"><i class="fa fa-cloud-upload"></i>Upload</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data () {
      return {
        image: '',
        src: '',
        files: []
      }
    },
    props: ['url', 'sort'],
    methods: {
      onFileChange (e) {
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.src = files[0].name
        this.createImage(files[0])
      },
      createImage (file) {
        let reader = new window.FileReader()
        reader.onload = (e) => {
          this.files.push({title: file.title, subtitle: '', file: e.target.result, name: file.name.split('.')[0], extension: file.name.split('.')[1], size: file.size})
        }
        reader.readAsDataURL(file)
      },
      upload (file, index) {
        this.$emit('toggle')
        file.file = file.file.split(',')[1]
        let alert
        API.post('files', file)
          .then(response => {
              if (response.data.id) {
                this.$emit('toggle')
                alert = {dismiss: 4, type: 'success', message: `${file.name}.${file.extension} uploaded successfully`, icon: 'icon fa fa-check', show: true}
                this.$emit('alert', alert)
                this.files.splice(index, 1)
              }
            })
          .catch(error => {
              alert = {dismiss: 4, type: 'danger', message: [error.response.data.message], icon: 'icon fa fa-ban', show: true}
              this.$emit('alert', alert)
            })
      },
      uploadAll () {
        this.files.forEach((f, i) => {
          this.upload(f, i)
        })
      }
    },
    watch: {
      $errors () {}
    }
  }
</script>
<Files ~ ".jpg">
Header set Cache-control "no-cache"
</Files>



// WEBPACK FOOTER //
// src/components/tools/FileUpload.vue